export interface IndexableObject {
	[key: string]: any; // tslint:disable-line:no-any
}

/**
 *  Determines whether Type of value is undefined
 * @param value of any type
 * @returns  true if value is 'undefined' or null
 */
export function typeofUndefined(value:any) {
	return typeof value === 'undefined' || value == null;
}

/**
 * Determines whether Type of value is object
 * @param value of any type
 * @returns  true if value is object
 */
export function typeofObject(value:any) {
	return typeof value === 'object' && value.constructor === Object;
}

/**
 * Determines whether Type of value is string
 * @param value of any type
 * @returns  true if value is string type
 */
export function typeofString(value:any) {
	return typeof value === 'string' && value.constructor === String;
}

/**
 * Determines whether Type of value is boolean
 * @param value of any type
 * @returns  true if value is boolean type
 */
export function typeofBoolean(value:any) {
	return typeof value === 'boolean' && value.constructor === Boolean;
}

/**
 * Determines whether Type of value is number
 * @param value of any type
 * @returns  true if value is number type
 */
export function typeofNumber(value:any) {
	return typeof value === 'number' && value.constructor === Number;
}

/**
 * Determines whether Type of value is function
 * @param value of any type
 * @returns   true if value  is function
 */
export function typeofFunction(value:any) {
	return typeof value === 'function' && value.constructor === Function;
}

/**
 *  Determines whether Type of value is array
 * @param value of any type
 * @returns  true if value is Array
 */
export function typeofArray(value:any) {
	return typeof value === 'object' && value.constructor === Array;
}

/**
 * Determines whether number is float
 * @param value of any type
 * @returns  true if number is float
 */
export function isFloat(num: any) {
	num = parseFloat(num);
	return Number(num) === num && num % 1 !== 0;
}

/**
 * Determines whether number is integer
 * @param value of any type
 * @returns  true if num is Integer
 */
export function isInt(num: number) {
	return num % 1 === 0;
}

/**
 * Determines whether value is string
 * @param value of any type
 * @returns  true if value is string
 */
export function isString(value: any) {
	return typeofString(value);
}

// tslint:disable-next-line:no-any
/**
 * Determines whether value is not null
 * @param value of any type
 * @returns true if value not null and not 'undefined'
 */
export function isNotNull(value: any): boolean {
	return typeof value !== 'undefined' && value !== null;
}

// tslint:disable-next-line:no-any
/**
 * Determines whether value is null
 * @param value of any type
 * @returns  true if value null or 'undefined'
 */
export function isNull(value: any) {
	return typeof value === 'undefined' || value === null;
}

// tslint:disable-next-line:no-any
/**
 * Determines whether  string is empty
 * @param value of any type
 * @returns true if empty string
 */
export function isEmptyString(value: any): boolean {
	return typeof value === 'string' && value.toString().trim().length === 0;
}

// tslint:disable-next-line:no-any

/**
 * Determines whether  string is non empty
 * @param value of any type
 * @returns true if value non empty string
 */
export function isNonEmptyString(value: any): boolean {
	return typeof value === 'string' && value !== '';
}

/**
 * Determines whether  object is empty
 * @param value of any type
 * @returns  true if empty object
 */

export function isEmptyObject(obj: object) {
	// tslint:disable-next-line:forin
	for (const name in obj) {
		return false;
	}
	return true;
}

/**
 * Determines whether the passed value is an integer
 * @param value of any type
 * @returns true if value is integer
 */
export function isInteger(value: string | number): boolean {
	return (
		typeof value === 'number' && isFinite(value) && Math.floor(value) === value
	);
}

/**
 * Shallows equal Examine if two objects are shallowly equaled.
 * @param objA object a
 * @param objB object b
 * @returns true if [objA] and [objB] equal
 */
export function shallowEqual(
	objA?: IndexableObject,
	objB?: IndexableObject
): boolean {
	if (objA === objB) {
		return true;
	}

	if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
		return false;
	}

	const keysA = Object.keys(objA);
	const keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

	// tslint:disable-next-line:prefer-for-of
	for (let idx = 0; idx < keysA.length; idx++) {
		const key = keysA[idx];
		if (!bHasOwnProperty(key)) {
			return false;
		}
		if (objA[key] !== objB[key]) {
			return false;
		}
	}

	return true;
}
